
import { Button } from "@/components/ui/button";
import { LogIn, UserPlus } from "lucide-react";

const AuthButtons = () => {
  return (
    <>
      <Button variant="ghost" asChild>
        <a href="https://app.upfixe.com" className="flex items-center gap-2">
          <LogIn className="h-4 w-4" />
          Log in
        </a>
      </Button>
      <Button asChild>
        <a href="https://app.upfixe.com" className="flex items-center gap-2">
          <UserPlus className="h-4 w-4" />
          Sign up
        </a>
      </Button>
    </>
  );
};

export default AuthButtons;
